// extracted by mini-css-extract-plugin
export default {"series":"zBQ0e","titleImage":"FGoe8","positionContentDetail":"DYw_D","fadeIn":"dqJOy","fadeInUp":"WCUi5","slideDownAppear":"r4TUJ","shake":"Fx0mL","zoomIn":"iTkB2","rotate":"UHmfq"};